import { render } from "./VarselKnapp.vue?vue&type=template&id=d8ccc420"
import script from "./VarselKnapp.vue?vue&type=script&lang=js"
export * from "./VarselKnapp.vue?vue&type=script&lang=js"

import "./VarselKnapp.vue?vue&type=style&index=0&id=d8ccc420&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__